import { PersonalDetails, getPersonalDetailsEndpoint } from 'cpes-common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData, updateData } = getSimpleDataFetchSlice<PersonalDetails, DefaultBusinessMarketApiErrorCode>({
    dataName: 'details',
    fetchCallback() {
        return CpDataApi.get<PersonalDetails>(getPersonalDetailsEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchMyProfile = fetchData;
export const updateMyProfile = updateData;
